import axios from "axios";
import getApiUrl from "src/utils/get-api-url";

const apiUrl = getApiUrl();

/**
 * Fetch fit reason categories and subcategories.
 *
 * @param {'UNDO_FIT'|'ROLLBACK'} type
 * @returns {Promise<Array>}
 */
export function getReasons(type) {
  return axios.get(`${apiUrl}/fit/reasons`, { params: { type } })
    .then(response => response.data);
}
